<div class="wrapper">
    <div class="container mt-5">
        <div class="card shadow-sm">
          <div class="card-header text-center">
            <h4>Recruiter Profile</h4>
          </div>
          <div class="card-body">
            <p><strong>Name:</strong> John Doe</p>
            <p><strong>Company:</strong> Tech Solutions</p>
            <p><strong>Email:</strong> johndoeexample.com</p>
            <p><strong>Location:</strong> New York, USA</p>
      
            <div class="d-flex justify-content-center mt-3">
              <button (click)="showJobs()" class="btn btn-primary mx-2">Jobs</button>
              <button (click)="showCompanyProfile()" class="btn btn-secondary mx-2">Company Profile</button>
            </div>
      
            <!-- Job Details Section -->
            <div *ngIf="showJobDetails" class="mt-4">
              <h5>Job Details</h5>
              <ul>
                <li>Job Title: Software Developer</li>
                <li>Location: New York</li>
                <li>Experience: 2+ years</li>
                <li>Salary: $80,000 - $100,000</li>
              </ul>
            </div>
      
            <!-- Company Profile Section -->
            <div *ngIf="showCompanyProfileDetails" class="mt-4">
              <h5>Company Profile</h5>
              <p>Company Name: Tech Solutions</p>
              <p>Industry: Software Development</p>
              <p>Founded: 2015</p>
              <p>Employees: 200+</p>
              <p>Location: New York, USA</p>
              <p>Website: <a href="https://techsolutions.com" target="_blank">www.techsolutions.com</a></p>
            </div>
          </div>
        </div>
      </div>
      
</div>